import React, { useState } from 'react'

import DaiContext from 'contexts/DaiContext'

const DaiProvider = ({ children }) => {
  const [expandedDaiActivityAnalysis, setExpandedDaiActivityAnalysis] =
    useState(false)

  return (
    <DaiContext.Provider
      value={{ expandedDaiActivityAnalysis, setExpandedDaiActivityAnalysis }}
    >
      {children}
    </DaiContext.Provider>
  )
}

export default DaiProvider
